@if (isMobile()) {
  <div class="table-filter-toolbar__mobile-filter-bar">
    <button
      type="button"
      class="table-filter-toolbar__icon-btn"
      [attr.aria-label]="searchAriaLabel()"
      (click)="onMobileSearchToggle()"
    >
      <ocp-themed-icon name="search.svg" />
    </button>

    @if (mobileSearchOpen()) {
      <div class="table-filter-toolbar__search">
        <label [for]="searchInputId" class="visually-hidden">{{ searchAriaLabel() }}</label>
        <input
          [id]="searchInputId"
          type="text"
          class="table-filter-toolbar__search-input"
          [placeholder]="searchAriaLabel()"
          [value]="searchQuery()"
          (input)="onSearchInput($event)"
        />
      </div>
    }

    <button
      type="button"
      class="table-filter-toolbar__icon-btn table-filter-toolbar__icon-btn--filter"
      [attr.aria-label]="filterAriaLabel()"
      [attr.aria-expanded]="mobileFiltersOpen()"
      (click)="mobileFiltersOpen.set(true)"
    >
      <ocp-themed-icon name="filter.svg" />
      @if (activeFilterValueCount() > 0) {
        <span class="table-filter-toolbar__icon-btn-badge">{{ activeFilterValueCount() }}</span>
      }
    </button>
  </div>

  @if (filterState().hasActiveFilters()) {
    <div class="table-filter-toolbar__active-filter-chips">
      @for (field of filterState().fields; track field.key) {
        @if (field.mobileSubpage) {
          @if (filterState().getSelectedCount(field.key)(); as count) {
            @if (count > 0) {
              <span class="table-filter-toolbar__filter-chip">
                {{ field.labelKey | translate }} ({{ count }})
                <button
                  type="button"
                  class="table-filter-toolbar__filter-chip-remove"
                  [attr.aria-label]="filterRemoveAriaLabel()"
                  (click)="filterState().clearField(field.key)"
                >
                  <ocp-themed-icon name="cross.svg" [size]="9" />
                </button>
              </span>
            }
          }
        } @else {
          @for (option of getSelectedFilterOptions(field.key); track option.value) {
            <span class="table-filter-toolbar__filter-chip">
              @if (option.labelKey) {
                {{ option.labelKey | translate }}
              } @else {
                {{ option.label }}
              }
              <button
                type="button"
                class="table-filter-toolbar__filter-chip-remove"
                [attr.aria-label]="filterRemoveAriaLabel()"
                (click)="filterState().toggleValue(field.key, option.value)"
              >
                <ocp-themed-icon name="cross.svg" [size]="9" />
              </button>
            </span>
          }
        }
      }

      <button
        type="button"
        class="table-filter-toolbar__clear-filters-btn"
        (click)="filterState().clearAll()"
      >
        {{ clearAllLabel() }}
      </button>
    </div>
  }

  @if (mobileFiltersOpen()) {
    <ocp-table-filter-mobile-panel
      [filterState]="filterState()"
      [title]="panelTitle()"
      [showAllLabel]="showAllLabel()"
      [clearAllLabel]="clearAllLabel()"
      [applyLabel]="applyLabel()"
      [selectLabel]="selectLabel()"
      [closeAriaLabel]="closeAriaLabel()"
      [backAriaLabel]="backAriaLabel()"
      [selectedCountLabel]="selectedCountLabel()"
      (panelClose)="mobileFiltersOpen.set(false)"
    />
  }
} @else {
  <div class="table-filter-toolbar__filter-bar">
    <div class="table-filter-toolbar__search">
      <ocp-themed-icon class="table-filter-toolbar__search-icon" name="search.svg" />
      <label [for]="searchInputId" class="visually-hidden">{{ searchAriaLabel() }}</label>
      <input
        [id]="searchInputId"
        type="text"
        class="table-filter-toolbar__search-input"
        [placeholder]="searchAriaLabel()"
        [value]="searchQuery()"
        (input)="onSearchInput($event)"
      />
    </div>

    @for (field of filterState().fields; track field.key) {
      <ocp-table-filter-dropdown
        [label]="field.labelKey | translate"
        [showAllLabel]="showAllLabel()"
        [options]="filterState().getFieldOptions(field.key)()"
        [selected]="filterState().getSelectedValues(field.key)()"
        (toggleOption)="filterState().toggleValue(field.key, $event)"
        (clearAll)="filterState().clearField(field.key)"
      />
    }

    @if (filterState().hasActiveFilters()) {
      <button
        type="button"
        class="table-filter-toolbar__clear-filters-btn"
        (click)="filterState().clearAll()"
      >
        {{ clearAllLabel() }}
      </button>
    }
  </div>
}
